module.exports = __webpack_public_path__ + "img/ds1.f492e4ba.png";